<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<p class="tit">The Available Wife</p>
<p class="tit1"><i>Part 2</i></p>
<p class="tit2">Carla Pennington</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?811a0ca2